var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCreateNewFeed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81,39.32h30.79V8.53H8.81v30.79Zm6.64-17.39h6.75v-6.76c0-1.11,.89-2,2-2s2,.89,2,2v6.76h6.76c1.11,0,2,.89,2,2s-.89,2-2,2h-6.76v6.75c0,1.11-.89,2-2,2s-2-.89-2-2v-6.75h-6.75c-1.11,0-2-.89-2-2s.89-2,2-2Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.6,4.53H6.81c-1.11,0-2,.89-2,2V41.32c0,1.11,.89,2,2,2H41.6c1.11,0,2-.89,2-2V6.53c0-1.11-.89-2-2-2Zm-2,34.79H8.81V8.53h30.79v30.79Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.45,25.93h6.75v6.75c0,1.11,.89,2,2,2s2-.89,2-2v-6.75h6.76c1.11,0,2-.89,2-2s-.89-2-2-2h-6.76v-6.76c0-1.11-.89-2-2-2s-2,.89-2,2v6.76h-6.75c-1.11,0-2,.89-2,2s.89,2,2,2Z",
    fill: outlineColor
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCreateNewFeed);
export default __webpack_public_path__ + "static/media/ico-create-new-feed.d6cd019956f4b0e4e0413b5aad1fc132.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;